import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import Select, { components } from "react-select";
import CreatableSelect from 'react-select/creatable';
import PropTypes from "prop-types"
import ReactDrawer from 'react-drawer';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Progress,
  Row,
  TabContent,
  TabPane,
  Button,
  Spinner
} from "reactstrap"

import classnames from "classnames"
import { Link, useHistory } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert"

import { getCategoriesAndSubCategories as onGetCategoriesAndSubCategories } from "store/products/actions"
import { getAllSuppliers as onGetAllSuppliers } from "store/products/actions"
import { getAllBrands as onGetAllBrands } from "store/products/actions"
import { getAllTaxes as onGetAllTaxes } from "store/products/actions"
import { getAllManufacturers as onGetAllManufacturers } from "store/products/actions"
import { getAllUnits as onGetAllUnits } from "store/products/actions"
import { getAllHSNs as onGetAllHSNs } from "store/products/actions"
import { getAllColours as onGetAllColours } from "store/products/actions"
import { getAllSizes as onGetAllSizes } from "store/products/actions"
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { getProductForEdit as onGetProductForEdit} from "store/products/actions"
import { getProductsDropDown } from "helpers/backend_helper"
import { getProductsDropDownFromCache, getLastDraftPurchase, removeLastDraftPurchase } from "helpers/cache_helper"
import { resetErrorAndResp } from "store/products/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import CustomTextEditor from "../../components/Common/CustomTextEditor"
import COADropDown from "../../components/Product/COADropDown"
import FileUpload from "../../components/Common/FileUpload"
import RightDrawer from "../../components/Common/RightDrawer"
import {postImages} from "helpers/backend_helper"
import {getProductForEditDirect, getNextProductCode} from "helpers/backend_helper"

import Loader from "components/Common/Loader"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"

const AddProduct = props => {

  const producttabs = [{tabid:1,tabname:"Basic Details"},
  {tabid:2,tabname:"Account Details"}]
  const producttabswithecomm = [{tabid:1,tabname:"Basic Details"},
  {tabid:2,tabname:"Account Details"},
  {tabid:3,tabname:"More details"},
  {tabid:4,tabname:"Product Images"},
  {tabid:5,tabname:"Meta Data"}]

  const productTypeOptions = [
    {
      label: "Goods",
      value: "GOODS"
    },{
      label: "Services",
      value: "SERVICES"
    }
  ]

  const history = useHistory()
  const dispatch = useDispatch()

  const [activeTab, setactiveTab] = useState(1)
  const [passedSteps, setPassedSteps] = useState([1])

  const [categoryList, setCategoryList] = useState([])
  const [subCategoryList, setSubCategoryList] = useState([])
  const [subCategoryValue, setSubCategoryValue] = useState(null)
  const [currentAddedValue, setCurrentAddedValue] = useState()
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedHSN, setSelectedHSN] = useState(null)
  const [selectedUnit, setSelectedUnit] = useState(null)
  const [selectedManufacturer, setSelectedManufacturer] = useState(null)
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(null)
  const [selectedSupplier, setSelectedSupplier] = useState(null)
  const [selectedBrand, setSelectedBrand] = useState(null)
  const [selectedColour, setSelectedColour] = useState(null)
  const [selectedSize, setSelectedSize] = useState(null)
  const [selectedProductType, setSelectedProductType] = useState(productTypeOptions[0])
  const [isEdit, setIsEdit] = useState(false)
  const [showLoading, setShowLoading] = useState(false)
  const [confirmationId, setConfirmationId] = useState('')

  const [reset, doReset] = useState(0);
  const [highlightRows, setHighlightRows] = useState([{ idx: 1 , id:"", value: ""}])
  const [specificationRows, setSpecificationRows] = useState([{ idx: 1 , id:"", key: "", value: ""}])

  const getAnewUnitConversionRow = (index) => {
    return { 
      idx: index , 
      id:"", 
      value: "",
      conversionunit:"",
      conversionvalue:""
    }
  }

  const [unitConversionRows, setUnitConversionRows] = useState([getAnewUnitConversionRow(1)])
  const [unitListCopy, setUnitListCopy] = useState([])
  const [currentTabs, setCurrentTabs] = useState(producttabs)
  const [saleaccountid, setSaleaccountid] = useState()
  const [salereturnaccountid, setSalereturnaccountid] = useState()
  const [salediscountaccountid, setSalediscountaccountid] = useState()

  const [initialproductimages, setInitialproductimages] = useState([])
  const [initialproductdescription, setInitialproductdescription] = useState('')

  const [purchaseaccountid, setPurchaseaccountid] = useState()
  const [purchasereturnaccountid, setPurchasereturnaccountid] = useState()
  const [purchasediscountaccountid, setPurchasediscountaccountid] = useState()

  function initialiseProductDetails(){
    return {
      productid: "",
      productcode: "",
      productname: "",
      productcategory: "",
      productsubcategory: "",
      producthsn: "",
      productunit: "",
      productunitname: "",
      productmanufacturer: "",
      producttaxgroup: "",
      productsupplier: "",
      productbrand: "",
      producttype: "GOODS",
  
      productaltname: "",
      productsku: "",
      productcolour: "",
      productsize: "",
      multiunit: false,
      productactive: true,
      productwebactive: true,

      trackinventory: true,
      stockalertlevel: "5",
  
      productdescription: "",
      productimages: [],
      productimagenames: "",
  
      productmetatitle: "",
      productmetakeywords : "",
      productmetadescription: "",
  
      productspecifications: [],
      producthighlights: [],
  
      productspecificationidtoremove: [],
      producthighlightidtoremove: [],
  
      multiunitconversions:[],
      multiunitconversionidtoremove: [],
  
      saleaccountid : "",
      salereturnaccountid : "",
      salediscountaccountid : "",
  
      purchaseaccountid : "",
      purchasereturnaccountid : "",
      purchasediscountaccountid : "",
  
    }
  }
  const [productDetails, setProductDetails] = useState(initialiseProductDetails())

  const [validation, setValidation] = useState({
    productcode: null,
    productname: null,
    productcategory: null,
    productsubcategory: null,
    producthsn: null,
    productunit: null,
    productmanufacturer: null,
    producttaxgroup: null,
    productsupplier: null,
    productbrand: null,

    productaltname: null,
    productsku: null,
    productcolour: null,
    productsize: null
  })

  const mandatoryFields = ['productcode','productname','productcategory','producthsn','producttaxgroup','productunit']

  const { settings,product,categorySubCategory,supplierList, brandList,taxList,manufacturerList,unitList,hsnList,colourList,sizeList, response, error, addMajorInProgress} = useSelector(state => ({
    categorySubCategory: state.Products.categories,
    supplierList: state.Products.suppliers,
    brandList: state.Products.brands,
    taxList: state.Products.taxes,
    manufacturerList: state.Products.manufacturers,
    unitList: state.Products.units,
    hsnList: state.Products.hsns,
    colourList: state.Products.colours,
    sizeList: state.Products.sizes,
    settings: state.Products.settings,

    product: state.Products.product,

    response: state.Products.response,
    error: state.Products.error,
    addMajorInProgress: state.Products.addMajorInProgress
  }))

  const [newItemToAdd, setNewItemToAdd] = useState()
  const [enteredText, setEnteredText] = useState('')
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [productForEdit, setProductForEdit] = useState({})
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [productList, setProductList] = useState([])
  const [selectedDuplicatePdt, setSelectedDuplicatePdt] = useState(null)
  const [lastPurchaseDraft, setLastPurchaseDraft] = useState()

  const {
    match: { params },
  } = props

  function initialiseForm(){
    setSelectedCategory(null)
    setSubCategoryValue(null)
    setSelectedHSN(null)
    setSelectedUnit(null)
    setSelectedManufacturer(null)
    setSelectedTaxGroup(null)
    setSelectedSupplier(null)
    setSelectedBrand(null)
    setSelectedColour(null)
    setSelectedSize(null)
    setHighlightRows([{ idx: 1 , id:"", value: ""}])
    setSpecificationRows([{ idx: 1 , id:"", key: "", value: ""}])
    setUnitConversionRows([getAnewUnitConversionRow(1)])
    setProductDetails(initialiseProductDetails())
    setFilteredUnitListCopy('')
    setProductForEdit({})
    doReset(prev => prev + 1)
    setSelectedProductType(productTypeOptions[0])
    setSelectedDuplicatePdt(null)
  }

  useEffect(() => {
    if (params && params.id) {
      setIsEdit(true)
      setShowLoading(true)
      //dispatch(onGetProductForEdit(params.id))
      getProductDetail(params.id)
    } else {
      fetchNextProductCode()
      //dispatch(onGetProductDetail(1))
    }
    const lastPuchase = getLastDraftPurchase()
    if(lastPuchase){
      setLastPurchaseDraft(lastPuchase)
    }
  }, [])

  async function getProductDetail(pdtid){
    const response = await getProductForEditDirect(pdtid)
    //console.log('response:'+JSON.stringify(response))
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.productid){
      setProductForEdit((response))
    }
    setShowLoading(false)
  }
 
  /*
  useEffect(() => {
    if (product && isEdit && params.id == product.productid) {
      console.log('product:'+JSON.stringify(product))
      //setEditOnLoadInProgress(false)
      //setProductForEdit((product))
    }
  }, [product])
  */

  useEffect(() => {
    if(settings && settings.length > 0){
      const ecomEnabled = settings.filter(each => each.settingid == 'ECOMMERCE_FLAG')
      if(ecomEnabled && ecomEnabled.length > 0){
        const ecomEnabledValue = ecomEnabled[0].settingvalue
        if(ecomEnabledValue == 'Yes'){
          setCurrentTabs(producttabswithecomm)
        }
      }
    }
  }, [settings]);
  
  useEffect(() => {
    if (productForEdit && isEdit && params.id == productForEdit.productid) {
      const pdtSubCategoryOption = subCategoryList.filter(each => each.value === productForEdit.productsubcategoryid)
      if(pdtSubCategoryOption && pdtSubCategoryOption != null){
        setSubCategoryValue(pdtSubCategoryOption)
      }
    }
  }, [subCategoryList])

  function initialiseFromExisting(productForEdit, isDuplicate){

    const pdtCategoryOption = categoryList.filter(each => each.value === productForEdit.productcategoryid)
    if(pdtCategoryOption && pdtCategoryOption != null && pdtCategoryOption.length > 0){
      setSelectedCategory(pdtCategoryOption[0])
      setSubCategoryOptions(pdtCategoryOption[0].value)
    }

    const hsnOption = hsnList.filter(each => each.value === productForEdit.producthsnid)
    if(hsnOption && hsnOption.length == 1){
      setSelectedHSN(hsnOption[0])
    }

    const unitOption = unitList.filter(each => each.value === productForEdit.productunitid)
    let unitName = ''
    if(unitOption && unitOption.length == 1){
      setSelectedUnit(unitOption[0])
      unitName = unitOption[0].name
      setFilteredUnitListCopy(unitOption[0].value)
    }

    const manuOption = manufacturerList.filter(each => each.value === productForEdit.productmanufacturerid)
    if(manuOption && manuOption.length == 1){
      setSelectedManufacturer(manuOption[0])
    }

    const taxOption = taxList.filter(each => each.value === productForEdit.producttaxgroupid)
    if(taxOption && taxOption.length == 1){
      setSelectedTaxGroup(taxOption[0])
    }

    const suppOption = supplierList.filter(each => each.value === productForEdit.productsupplierid)
    if(suppOption && suppOption.length == 1){
      setSelectedSupplier(suppOption[0])
    }
    
    const brandOption = brandList.filter(each => each.value === productForEdit.productbrandid)
    if(brandOption && brandOption.length == 1){
      setSelectedBrand(brandOption[0])
    }
    
    const colourOption = colourList.filter(each => each.value === productForEdit.productcolourid)
    if(colourOption && colourOption.length == 1){
      setSelectedColour(colourOption[0])
    }
    
    const sizeOption = sizeList.filter(each => each.value === productForEdit.productsizeid)
    if(sizeOption && sizeOption.length == 1){
      setSelectedSize(sizeOption[0])
    }

    const productTypeOption = productTypeOptions.filter(each => each.value === productForEdit.producttype)
    if(productTypeOption && productTypeOption.length == 1){
      setSelectedProductType(productTypeOption[0])
    }

    /*
    let alreadyExistingFileNames = ''
    if(productForEdit.productimages && productForEdit.productimages.length > 0){
      alreadyExistingFileNames = productForEdit.productimages.join()
      //console.log('alreadyExistingFileNames::'+alreadyExistingFileNames)
    }
    */

    const initialHighLightRows = []
    if(productForEdit.producthighlights && productForEdit.producthighlights.length > 0){
      productForEdit.producthighlights.forEach((each, index) => {
        initialHighLightRows.push({
          idx:  index+1, 
          id:  each.id, 
          value: each.value
        })
      })
      setHighlightRows(initialHighLightRows)
    }

    const initialSpecificationRows = []
    if(productForEdit.productspecifications && productForEdit.productspecifications.length > 0){
      productForEdit.productspecifications.forEach((each, index) => {
        initialSpecificationRows.push({
          idx:  index+1, 
          id:  each.id,
          key:  each.key, 
          value: each.value
        })
      })
      setSpecificationRows(initialSpecificationRows)
    }

    const initialMultiUnitRows = []
    if(productForEdit.multiunit && productForEdit.multiunitconversions && productForEdit.multiunitconversions.length > 0){
      productForEdit.multiunitconversions.forEach((each, index) => {
        initialMultiUnitRows.push({
          ...each,
          idx:  index+1, 
        })
      })
      setUnitConversionRows(initialMultiUnitRows)
    }

    setInitialproductimages(productForEdit.productimages?productForEdit.productimages:[])
    setInitialproductdescription(productForEdit.productdescription ? productForEdit.productdescription : '')

    setProductDetails({
      ...productDetails,
      productid: isDuplicate ? '': productForEdit.productid,
      productcode: isDuplicate? productDetails.productcode : productForEdit.productcode,
      productname: productForEdit.productname,
      productcategory : productForEdit.productcategoryid,
      productsubcategory: productForEdit.productsubcategoryid,
      producthsn: productForEdit.producthsnid,
      productunit: productForEdit.productunitid,
      productunitname:unitName,
      productmanufacturer: productForEdit.productmanufacturerid,
      producttaxgroup: productForEdit.producttaxgroupid,
      productsupplier: productForEdit.productsupplierid,
      productbrand: productForEdit.productbrandid,
      producttype: productForEdit.producttype,

      productaltname: productForEdit.productaltname,
      productsku: productForEdit.productsku,
      productcolour: productForEdit.productcolourid,
      productsize: productForEdit.productsizeid,
      productactive: productForEdit.productactive,
      multiunit: productForEdit.multiunit,
      productwebactive: productForEdit.productwebactive,

      trackinventory: productForEdit.trackinventory,
      stockalertlevel: productForEdit.stockalertlevel,

      productdescription: productForEdit.productdescription,
      productdescriptionid: productForEdit.productdescriptionid,
      productimages: [],
      productimagenames: "",
      productimageid: productForEdit.productimageid,

      productmetaid: productForEdit.productmetaid,
      productmetatitle: productForEdit.productmetatitle,
      productmetakeywords : productForEdit.productmetakeywords,
      productmetadescription: productForEdit.productmetadescription,

      productspecifications: initialSpecificationRows,
      producthighlights: initialHighLightRows,

      saleaccountid : productForEdit.saleaccountid,
      salereturnaccountid : productForEdit.salereturnaccountid,
      salediscountaccountid : productForEdit.salediscountaccountid,

      purchaseaccountid : productForEdit.purchaseaccountid,
      purchasereturnaccountid : productForEdit.purchasereturnaccountid,
      purchasediscountaccountid :productForEdit.purchasediscountaccountid,
    })
  }

  useEffect(() => {
    if (productForEdit && isEdit && params.id == productForEdit.productid) {
      initialiseFromExisting(productForEdit, false)
    }
  }, [productForEdit])

  function handleDuplicateProduct(referencepdt){
    //console.log('referencepdt:'+JSON.stringify(referencepdt))
    setShowLoading(true)
    getProductForEditDirect(referencepdt.productid).then(resp =>{
      //console.log('resp:'+JSON.stringify(resp))
      initialiseFromExisting(resp, true)
      setShowLoading(false)
    })
  }

  const onNewlyAddedValue = (value) => {
    setCurrentAddedValue(value)
  }
  const onDrawerClose = () => {
    setOpen(false);
  }

  const onTextEditorValueChange = (value) => {
    setProductDetails({
      ...productDetails,
      productdescription : value
    })
  }

  const onFileUploadValueChange = (value) => {
    setProductDetails({
      ...productDetails,
      productimages : value
    })
  }

  useEffect(() => {
    dispatch(onGetCategoriesAndSubCategories(true))
    dispatch(onGetAllBrands(true))
    dispatch(onGetAllSuppliers(true))
    dispatch(onGetAllTaxes(true))
    dispatch(onGetAllManufacturers(true))
    dispatch(onGetAllUnits(true))
    dispatch(onGetAllHSNs(true))
    dispatch(onGetAllColours(true))
    dispatch(onGetAllSizes(true))
    dispatch(onGetStoreSettings(true))
    getPdtDropDown(true)
  }, [dispatch]);

  async function fetchNextProductCode(){
    if(!isEdit && productDetails.productcode == ''){
      const result = await getNextProductCode()

      if(result && result.status == 'success' && result.response && productDetails.productcode == ''){
        setProductDetails({
          ...productDetails,
          productcode : result.response
        })
      }
    }
  }

  async function getPdtDropDown(fromCache){
    //const pdtdropdown = await getProductsDropDown()
    const pdtdropdown = await getProductsDropDownFromCache(fromCache)
    setProductList(pdtdropdown)
  }

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'HSN'){
      const newlyAddedOption = hsnList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedHSN(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          producthsn : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.producthsnid){
      const hsnOption = hsnList.filter(each => each.value === productForEdit.producthsnid)
      if(hsnOption && hsnOption.length == 1){
        setSelectedHSN(hsnOption[0])
      }
    }
  }, [hsnList])

  useEffect(() => {
    //setUnitListCopy(unitList)
    if(currentAddedValue && newItemToAdd == 'Unit'){
      const newlyAddedOption = unitList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedUnit(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          productunit : newlyAddedOption[0].value
        })
        setFilteredUnitListCopy(newlyAddedOption[0].value)
      }
    }
    else if(productForEdit && productForEdit.productunitid){
      const unitOption = unitList.filter(each => each.value === productForEdit.productunitid)
      if(unitOption && unitOption.length == 1){
        setSelectedUnit(unitOption[0])
      }
    }
  }, [unitList])

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'Manufacturer'){ 
      const newlyAddedOption = manufacturerList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedManufacturer(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          productmanufacturer : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.productmanufacturerid){
      const manuOption = manufacturerList.filter(each => each.value === productForEdit.productmanufacturerid)
      if(manuOption && manuOption.length == 1){
        setSelectedManufacturer(manuOption[0])
      }
    }
  }, [manufacturerList])

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'Tax'){
      const newlyAddedOption = taxList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedTaxGroup(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          producttaxgroup : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.producttaxgroupid){
      const taxOption = taxList.filter(each => each.value === productForEdit.producttaxgroupid)
      if(taxOption && taxOption.length == 1){
        setSelectedTaxGroup(taxOption[0])
      }
    }
  }, [taxList])

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'Supplier'){
      const newlyAddedOption = supplierList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedSupplier(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          productsupplier : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.productsupplierid){
      const suppOption = supplierList.filter(each => each.value === productForEdit.productsupplierid)
      if(suppOption && suppOption.length == 1){
        setSelectedSupplier(suppOption[0])
      }
    }
  }, [supplierList])

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'Brand'){
      const newlyAddedOption = brandList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedBrand(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          productbrand : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.productbrandid){
      const brandOption = brandList.filter(each => each.value === productForEdit.productbrandid)
      if(brandOption && brandOption.length == 1){
        setSelectedBrand(brandOption[0])
      }
    }
  }, [brandList])

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'Colour'){
      const newlyAddedOption = colourList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedColour(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          productcolour : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.productcolourid){
      const colourOption = colourList.filter(each => each.value === productForEdit.productcolourid)
      if(colourOption && colourOption.length == 1){
        setSelectedColour(colourOption[0])
      }
    }
  }, [colourList])

  useEffect(() => {
    if(currentAddedValue && newItemToAdd == 'Size'){
      const newlyAddedOption = sizeList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedSize(newlyAddedOption[0])
        setProductDetails({
          ...productDetails,
          productsize : newlyAddedOption[0].value
        })
      }
    }
    else if(productForEdit && productForEdit.productsizeid){
      const sizeOption = sizeList.filter(each => each.value === productForEdit.productsizeid)
      if(sizeOption && sizeOption.length == 1){
        setSelectedSize(sizeOption[0])
      }
    }
  }, [sizeList])

  useEffect(() => {
    let categoryArray = [];
    let newlyAddedOption = null;
    for (const [key, value] of Object.entries(categorySubCategory)) {
      categoryArray.push({
        label : value.categoryName,
        value: value.categoryId
      })
      if(newItemToAdd == 'Category' && value.categoryId == currentAddedValue){
        newlyAddedOption = {
          label : value.categoryName,
          value: value.categoryId
        }
      }
    }
    setCategoryList(categoryArray)
    if(newlyAddedOption != null){
      setSelectedCategory(newlyAddedOption)
      setSubCategoryOptions(newlyAddedOption.value)
      setProductDetails({
        ...productDetails,
        productcategory : newlyAddedOption.value
      })
    }
    else if(productDetails.productcategory != ''){
      setSubCategoryOptions(productDetails.productcategory)
    }

    if(productForEdit && productForEdit.productcategoryid){
      const pdtCategoryOption = categoryArray.filter(each => each.value === productForEdit.productcategoryid)
      if(pdtCategoryOption && pdtCategoryOption != null && pdtCategoryOption.length > 0){
        setSelectedCategory(pdtCategoryOption[0])
        setSubCategoryOptions(pdtCategoryOption[0].value)
      }
    }

  }, [categorySubCategory])

  function setSubCategoryOptions(selectedCategory) {
    setSubCategoryValue(null)
    let subCategoryArray = [];
    let newlyAddedSubCatOption = null;
    if(categorySubCategory[selectedCategory] && categorySubCategory[selectedCategory].subCategoryList){
      let subCatList = categorySubCategory[selectedCategory].subCategoryList
      subCatList.forEach(function (item, index) {
        subCategoryArray.push({
          label : item.categoryName,
          value: item.categoryId
        })

        if(newItemToAdd == 'Sub Category' && item.categoryId == currentAddedValue){
          newlyAddedSubCatOption = {
            label : item.categoryName,
            value: item.categoryId
          }
        }
      });
    }
    setSubCategoryList(subCategoryArray)
    if(newlyAddedSubCatOption != null){
      setSubCategoryValue(newlyAddedSubCatOption)
      setProductDetails({
        ...productDetails,
        productsubcategory : newlyAddedSubCatOption.value
      })
    }
  }

  /*
  useEffect(() => {
    console.log('>>:'+JSON.stringify(productDetails))
  }, [productDetails]);
  */

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  function addNewItem(item) {
    dispatch(resetErrorAndResp())
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }

  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  function validateForm(){
    const modifiedV = { ...validation }
    let formValid = true;
    mandatoryFields.forEach(eachItem =>{
      if(productDetails[eachItem] && productDetails[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })

    if(productDetails.multiunit){
      //console.log('unitConversionRows:'+JSON.stringify(unitConversionRows))
      //console.log('productDetails.productunit:'+JSON.stringify(productDetails.productunit))
      
      for (let index = 0; index < unitConversionRows.length; index++) {
        const lastRow = unitConversionRows[index];
        if(lastRow["conversionunit"] && lastRow["conversionunit"] != ""){
          modifiedV["productmultiunit-"+(index+1)] = true
        }
        else{
          modifiedV["productmultiunit-"+(index+1)] = false
          formValid = false
        }
    
        if(lastRow["conversionvalue"] && lastRow["conversionvalue"] != "" && isNumber(lastRow["conversionvalue"]) && Number(lastRow["conversionvalue"]) > 0){
          modifiedV["productmultiunitval-"+(index+1)] = true
        }
        else{
          modifiedV["productmultiunitval-"+(index+1)] = false
          formValid = false
        }

        if(lastRow["conversionunit"] == productDetails.productunit){
          modifiedV["productmultiunitduplicate-"+(index+1)] = false
          formValid = false
        }
        else{
          modifiedV["productmultiunitduplicate-"+(index+1)] = true
        }

      }
    }

    setValidation(modifiedV)
    return formValid
  }

  function addProduct(){

    let formValid = validateForm()

    if(formValid){

      setProductDetails({
        ...productDetails,
        productspecifications : specificationRows,
        producthighlights : highlightRows,
      })

      //console.log('<<Submit>>:'+JSON.stringify(productDetails))
      if(productDetails.productimages && productDetails.productimages.length > 0){
        setShowLoading(true)
        let alreadyExistingFileNames = ''
        if(isEdit && productForEdit.productimages && productForEdit.productimages.length > 0){
          productForEdit.productimages.forEach(eachExisting => {
            const result = productDetails.productimages.filter(newImage => newImage.preview === eachExisting)
            if(result.length > 0){
              alreadyExistingFileNames = alreadyExistingFileNames + eachExisting + ','
            }
          })
        }
        uploadImageCallBack(productDetails.productimages).then(result => {
          if(result != ''){
            let productTemp = { ...productDetails }
            productTemp["productimagenames"] = alreadyExistingFileNames + result
            submitCreateNewProduct(productTemp)
          }
        })
      }
      else{
        submitCreateNewProduct(productDetails)
      }
    }
  }

  function saveEditProduct(){
    let formValid = validateForm()

    if(formValid){

      setProductDetails({
        ...productDetails,
        productspecifications : specificationRows,
        producthighlights : highlightRows,
      })

      //console.log('<<Submit Edit>>:'+JSON.stringify(productDetails))
      if(productDetails.productimages && productDetails.productimages.length > 0){
        setShowLoading(true)
        let alreadyExistingFileNames = ''
        if(isEdit && productForEdit.productimages && productForEdit.productimages.length > 0){
          productForEdit.productimages.forEach(eachExisting => {
            const result = productDetails.productimages.filter(newImage => newImage.preview === eachExisting)
            if(result.length > 0){
              alreadyExistingFileNames = alreadyExistingFileNames + eachExisting + ','
            }
          })
        }
        uploadImageCallBack(productDetails.productimages).then(result => {
          if(result != ''){
            let productTemp = { ...productDetails }
            productTemp["productimagenames"] = alreadyExistingFileNames + result
            submitEditProduct(productTemp)
          }
        })
      }
      else{
        submitEditProduct(productDetails)
      }
    }
  }

  async function submitEditProduct(pdtDetails) {
    pdtDetails["multiunitconversions"] = unitConversionRows
    pdtDetails = updateAccountDetails(pdtDetails)
    setShowLoading(true)
    const response = await onEditItemDirect(pdtDetails, 'Product')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      getPdtDropDown(false)
      setConfirmationId(pdtDetails.productid)
      setShowSuccessPopUp(true)
      setSuccessMessage('Product updated successfully.')
    }
    setShowLoading(false)
  }

  function updateAccountDetails(pdtDetails){
    pdtDetails["saleaccountid"] = saleaccountid
    pdtDetails["salereturnaccountid"] = salereturnaccountid
    pdtDetails["salediscountaccountid"] = salediscountaccountid
    pdtDetails["purchaseaccountid"] = purchaseaccountid
    pdtDetails["purchasereturnaccountid"] = purchasereturnaccountid
    pdtDetails["purchasediscountaccountid"] = purchasediscountaccountid

    return pdtDetails
  }

  async function submitCreateNewProduct(pdtDetails) {
    pdtDetails["multiunitconversions"] = unitConversionRows
    pdtDetails = updateAccountDetails(pdtDetails)
    setShowLoading(true)
    const response = await onAddItemDirect(pdtDetails, 'Product')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      getPdtDropDown(false)
      setConfirmationId(response.confirmation_code)
      setShowSuccessPopUp(true)
      setSuccessMessage('New product addedd successfully.')
    }
    setShowLoading(false)
  }

  /*
  useEffect(() => {
    console.log('addMajorInProgress:>'+JSON.stringify(addMajorInProgress))
    if(response && response.status && response.status == 'success'){
     
    }

    console.log('error:>'+JSON.stringify(error))
  }, [error,response,addMajorInProgress])
  */

  const uploadImageCallBack =  async (files) => {
    const data = new FormData();
    files.map((file, index) => {
      data.append(`files`, file);
    });
    const response =  await postImages(data)
    if(response.status == 'success'){
      return response.url
    }
    else{
      return ""
    }
  }

  function handleAddRowHighlights() {
    const modifiedRows = [...highlightRows]
    modifiedRows.push({ idx: modifiedRows.length + 1, id:"", value:"" })
    setHighlightRows(modifiedRows)
  }

  function handleRemoveRowHighlights(rowdata, id) {
    var modifiedRows = [...highlightRows]
    modifiedRows = modifiedRows.filter(x => x["idx"] !== id)
    var updatedRows = [];
    modifiedRows.map((row,index) =>{
      updatedRows.push({ idx: index+1 , id:row.id, value: row.value})
    })
    setHighlightRows(updatedRows)

    const currentRows = productDetails.producthighlightidtoremove
    currentRows.push(rowdata.id)
    setProductDetails({
      ...productDetails,
      producthighlightidtoremove : currentRows
    })
  }

  function handleHighlightsChange(id, value) {
    var modifiedRows = [...highlightRows]
    modifiedRows = modifiedRows.map(row => row["idx"] == id ? {idx:id, id: row["id"], value: value} : row)
    setHighlightRows(modifiedRows)
  }

  
  function handleAddRowSpecifications() {
    const modifiedRows = [...specificationRows]
    modifiedRows.push({ idx: modifiedRows.length + 1, id: "", key: "", value: "" })
    setSpecificationRows(modifiedRows)
  }

  function handleRemoveRowSpecifications(rowdata, id) {
    var modifiedRows = [...specificationRows]
    modifiedRows = modifiedRows.filter(x => x["idx"] !== id)
    var updatedRows = [];
    modifiedRows.map((row,index) =>{
      updatedRows.push({ idx: index+1 , id: row.id, key: row.key, value: row.value})
    })
    setSpecificationRows(updatedRows)
    
    const currentRows = productDetails.productspecificationidtoremove
    currentRows.push(rowdata.id)
    setProductDetails({
      ...productDetails,
      productspecificationidtoremove : currentRows
    })
  }

  function handleSpecificationsChangeValue(id, value) {
    var modifiedRows = [...specificationRows]
    modifiedRows = modifiedRows.map(row => row["idx"] == id ? {idx:id, id:row["id"], key:row["key"], value: value} : row)
    setSpecificationRows(modifiedRows)
  }

  function handleSpecificationsChangeKey(id, key) {
    var modifiedRows = [...specificationRows]
    modifiedRows = modifiedRows.map(row => row["idx"] == id ? {idx:id, id:row["id"], key:key, value: row["value"]} : row)
    setSpecificationRows(modifiedRows)
  }

  useEffect(() => {
    setProductDetails({
      ...productDetails,
      productspecifications : specificationRows
    })
  }, [specificationRows]);

  useEffect(() => {
    setProductDetails({
      ...productDetails,
      producthighlights : highlightRows,
    })
  }, [highlightRows]);

  function handleUnitValueChange(id, unitValue) {
    var modifiedRows = [...unitConversionRows]
    modifiedRows = modifiedRows.map(eachRow => {

      if(eachRow["idx"] == id){
        return {
          ...eachRow,
          conversionvalue: unitValue
        }
      }
      else {
        return eachRow
      }
    })
    setUnitConversionRows(modifiedRows)
  }

  function handleUnitChange(id, unitoption) {
    var modifiedRows = [...unitConversionRows]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        return {
          ...eachRow,
          conversionunit: unitoption.value
        }
      }
      else {
        return eachRow
      }
    })
    setUnitConversionRows(modifiedRows)
  }

  function getSelectedUnit(idx){
    if(unitList && unitConversionRows && unitList.length > 0 && unitConversionRows.length > 0){
      const foundValue = unitList.filter(x => x["value"] == unitConversionRows[idx-1].conversionunit)
      return foundValue
    }
  }

  function setFilteredUnitListCopy(inpValue){
    const filtered = unitList.filter(x => x.value != inpValue)
    setUnitListCopy(filtered)
  }

  function getMultiUnitOptions(idx){
   const filteredOptions =  unitListCopy.filter(each => {
    const innerFound = unitConversionRows.filter(innerEach => innerEach.conversionunit == each.value)
    if(innerFound.length == 0){
      return each
    }
    })
    return filteredOptions
  }
  
  function addMoreRows(idx) {

    let currentRows = [...unitConversionRows]
    currentRows.push(getAnewUnitConversionRow(unitConversionRows.length+1))
    setUnitConversionRows(currentRows)
  }

  function handleRemoveOneRow(formRow, id) {

    var modifiedRows = [...unitConversionRows]
    modifiedRows = modifiedRows.filter(x => x["idx"] !== id)

    var updatedRows = [];
    modifiedRows.map((row,index) =>{
      updatedRows.push(
        {
          ...row, 
          idx: index+1
        })
    })

    setUnitConversionRows(updatedRows)
    
    const currentRows = productDetails.multiunitconversionidtoremove
    currentRows.push(formRow.id)
    setProductDetails({
      ...productDetails,
      multiunitconversionidtoremove : currentRows
    })
  }

  function validateMultiUnitChange(key,value){
    if(value && value != ""){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:false
      })
    }  
  }

  function validateTextNumberInput(key,value){
    if(value && value != "" && isNumber(value) && Number(value) > 0){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:true
      })
    }
  }

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }


  const onContinueEditing = () => {
    if(confirmationId != ''){
      history.push('/edit-product/'+confirmationId);
    }
 }

  const onCreateNewProduct = () => {
   if(isEdit){
    history.push('/add-product');
   }
   else{
    initialiseForm()
   }
}

const handleBackToPurchase =()=>{
  removeLastDraftPurchase()
  history.push(lastPurchaseDraft.link);
}
  
  /*
  useEffect(() => {
    console.log('unitConversionRows::'+JSON.stringify(unitConversionRows))
  }, [unitConversionRows]);
  */

  const msgStyles = {
    background: "skyblue",
    color: "white",
    //display: "block",
    //alignItems: "stretch"
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Product | Flamingo</title>
        </MetaTags>
        <Loader showLoader={showLoading} />
        <Container fluid={true}>
          {isEdit ? 
          <Breadcrumbs title="Products" breadcrumbItem="Edit Product" />
          :
          <Breadcrumbs title="Products" breadcrumbItem="Add Product" />
          }
          
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                      {(currentTabs || []).map((each, key) => (
                        <NavItem
                        className={classnames({ current: activeTab === each.tabid })}
                        key={key}
                      >
                        <NavLink
                          className={classnames({ current: activeTab === each.tabid })}
                          onClick={() => {
                            setactiveTab(each.tabid)
                          }}
                        >
                          <span className="number">{each.tabid}</span> {each.tabname}
                        </NavLink>
                      </NavItem>
                      ))}
                      </ul>
                    </div>
                    <div className="content clearfix mt-4">
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId={1}>
                          <Form>
                            {!isEdit && <Row>
                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="duplicatepdt">
                                      Duplicate an existing product
                                  </Label>
                                  <Select
                                    onChange={(e) => {
                                      setSelectedDuplicatePdt(e)
                                      handleDuplicateProduct(e)
                                    }}
                                    options={productList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id={"duplicatepdt"}
                                    value={selectedDuplicatePdt}
                                  />
                                </div>
                              </Col>
                              {lastPurchaseDraft && 
                              <Col className="text-end">
                                <Button
                                  color="info"
                                  className="btn btn-success me-2"
                                  onClick={() => {
                                    handleBackToPurchase()
                                  }}
                                  >
                                    <i className="bx bx-left-arrow-alt me-1"></i>Back to Purchase Entry
                                </Button>
                              </Col>
                              }
                            </Row>}
                            <Row>
                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="productcode">
                                    Product Code *
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="productcode"
                                    maxLength="100"
                                    value={productDetails.productcode || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productcode : e.target.value
                                      })
                                      onChangeValidation("productcode", e.target.value.trim())
                                    }}
                                  />
                                  {(validation["productcode"] === false) &&
                                    <div className="custom-error">
                                      Please enter a Product Code
                                    </div>
                                  }
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="productname">
                                    Product Name *
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="productname"
                                    maxLength="150"
                                    value={productDetails.productname || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productname : e.target.value
                                      })
                                      onChangeValidation("productname", e.target.value.trim())
                                    }}
                                  />
                                  {(validation["productname"] === false) &&
                                    <div className="custom-error">
                                      Please enter a Product Name
                                    </div>
                                  }
                                </div>
                              </Col>

                              <Col lg="2" >
                                <div className="mb-3">
                                  <Label for="productactive">
                                    Product Active
                                  </Label>
                                  <div className="square-switch mt-2">
                                    <input
                                      type="checkbox"
                                      id="square-switch1"
                                      switch="none"
                                      checked={productDetails.productactive}
                                      onChange={() => {
                                        setProductDetails({
                                          ...productDetails,
                                          productactive : !productDetails.productactive
                                        })
                                      }}
                                    />
                                    <label
                                      htmlFor="square-switch1"
                                      data-on-label="Yes"
                                      data-off-label="No"
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productcategory">
                                    Product Category *
                                  </Label>
                                  <CreatableSelect
                                    value={selectedCategory}
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productcategory : e.value
                                      })
                                      setSubCategoryOptions(e.value)
                                      setSelectedCategory(e)
                                      onChangeValidation("productcategory", e.value)
                                    }}
                                    options={categoryList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productcategory"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Category')
                                    }}
                                  />
                                  {(validation["productcategory"] === false) &&
                                    <div className="custom-error">
                                      Please select the Product Category
                                    </div>
                                  }
                                </div>
                              </Col>

                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productsubcategory">
                                    Product Sub Category
                                  </Label>
                                  <CreatableSelect
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productsubcategory : e.value
                                      })
                                      setSubCategoryValue(e)
                                    }}
                                    value={subCategoryValue}
                                    options={subCategoryList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productsubcategory"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Sub Category')
                                    }}
                                  />
                                </div>
                              </Col>

                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="producthsn">
                                    HSN *
                                  </Label>
                                  <CreatableSelect
                                    value={selectedHSN}
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        producthsn : e.value
                                      })
                                      setSelectedHSN(e)
                                      onChangeValidation("producthsn", e.value)
                                    }}
                                    options={hsnList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="producthsn"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('HSN')
                                    }}
                                  />
                                  {(validation["producthsn"] === false) &&
                                    <div className="custom-error">
                                      Please select the Product HSN
                                    </div>
                                  }
                                </div>
                              </Col>
                            </Row>

                            <Row>

                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productbrand">
                                    Brand
                                  </Label>
                                  <CreatableSelect
                                    value={selectedBrand}
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productbrand : e.value
                                      })
                                      setSelectedBrand(e)
                                      onChangeValidation("productbrand", e.value)
                                    }}
                                    options={brandList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productbrand"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Brand')
                                    }}
                                  />
                                  {(validation["productbrand"] === false) &&
                                    <div className="custom-error">
                                      Please select the Tax
                                    </div>
                                  }
                                </div>
                              </Col>
                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="producttaxgroup">
                                    Tax Group *
                                  </Label>
                                  <CreatableSelect
                                    value={selectedTaxGroup}
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        producttaxgroup : e.value
                                      })
                                      setSelectedTaxGroup(e)
                                      onChangeValidation("producttaxgroup", e.value)
                                    }}
                                    options={taxList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="producttaxgroup"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Tax')
                                    }}
                                  />
                                  {(validation["producttaxgroup"] === false) &&
                                    <div className="custom-error">
                                      Please select the Tax
                                    </div>
                                  }
                                </div>
                              </Col>
                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productsupplier">
                                    Supplier
                                  </Label>
                                  <CreatableSelect
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productsupplier : e.value
                                      })
                                      setSelectedSupplier(e)
                                    }}
                                    value={selectedSupplier}
                                    options={supplierList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productsupplier"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Supplier')
                                    }}
                                  />
                                </div>
                              </Col>
                              
                            </Row>
                            <Row>
                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productmanufacturer">
                                    Manufacturer
                                  </Label>
                                  <CreatableSelect
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productmanufacturer : e.value
                                      })
                                      setSelectedManufacturer(e)
                                    }}
                                    value={selectedManufacturer}
                                    options={manufacturerList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productmanufacturer"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Manufacturer')
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg="4">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productType">
                                    Product Type
                                  </Label>
                                  <Select
                                    onChange={(e) => {
                                      //console.log('pdt type:'+JSON.stringify(e))
                                      setProductDetails({
                                        ...productDetails,
                                        producttype : e.value
                                      })
                                      setSelectedProductType(e)
                                      if(e.value == 'SERVICES'){
                                        setProductDetails({
                                          ...productDetails,
                                          trackinventory : false,
                                          producttype : e.value
                                        })
                                      }
                                      else if(e.value == 'GOODS'){
                                        setProductDetails({
                                          ...productDetails,
                                          trackinventory : true,
                                          producttype : e.value
                                        })
                                      }
                                    }}
                                    value={selectedProductType}
                                    options={productTypeOptions}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productType"
                                  />
                                </div>
                              </Col>
                              <Col lg="2" >
                                <div className="mb-3">
                                  <Label for="trackinventory">
                                    Track Inventory
                                  </Label>
                                  <div className="square-switch mt-2">
                                    <input
                                      type="checkbox"
                                      id="square-switch5"
                                      switch="none"
                                      checked={productDetails.trackinventory}
                                      onChange={() => {
                                        setProductDetails({
                                          ...productDetails,
                                          trackinventory : !productDetails.trackinventory
                                        })
                                      }}
                                    />
                                    <label
                                      htmlFor="square-switch5"
                                      data-on-label="Yes"
                                      data-off-label="No"
                                    />
                                  </div>
                                </div>
                              </Col>
                              {productDetails.trackinventory && <Col lg="2">
                                <div className="mb-3">
                                  <Label for="stockalertlevel">
                                    Stock Alert Level
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="stockalertlevel"
                                    maxLength="10"
                                    value={productDetails.stockalertlevel || ''}
                                    onChange={e => {
                                      if(isNumber(e.target.value)){
                                        setProductDetails({
                                          ...productDetails,
                                          stockalertlevel : e.target.value
                                        })
                                        onChangeValidation("stockalertlevel", e.target.value.trim())
                                      }
                                    }}
                                  />
                                </div>
                              </Col>}

                            </Row>

                            <Row>
                              <Col lg="3">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productunit">
                                    Unit Type *
                                  </Label>
                                  <CreatableSelect
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productunit : e.value,
                                        productunitname : e.name
                                      })
                                      setSelectedUnit(e)
                                      onChangeValidation("productunit", e.value)
                                      setFilteredUnitListCopy(e.value)
                                    }}
                                    value={selectedUnit}
                                    options={unitList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productunit"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Unit')
                                    }}
                                  />
                                  {(validation["productunit"] === false) &&
                                    <div className="custom-error">
                                      Please select the Unit Type
                                    </div>
                                  }
                                </div>
                              </Col>

                              <Col lg="1" >
                                <div className="mb-3">
                                  <Label for="multiunit">
                                    Multi Unit
                                  </Label>
                                  <div className="square-switch mt-2">
                                    <input
                                      type="checkbox"
                                      id="square-switch21"
                                      switch="none"
                                      checked={productDetails.multiunit}
                                      onChange={() => {
                                        if(productDetails.productunit == ''){
                                          onChangeValidation("productunit", '')
                                        }
                                        else{
                                          setProductDetails({
                                            ...productDetails,
                                            multiunit : !productDetails.multiunit
                                          })
                                        }
                                      }}
                                    />
                                    <label
                                      htmlFor="square-switch21"
                                      data-on-label="Yes"
                                      data-off-label="No"
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            {productDetails.multiunit && 
                            <Row>
                            <Col lg="6">
                            <div className="inner-repeater mb-4">
                              <Label>Unit Conversion</Label>
                              <Row className="mb-1 no-gutters">
                                <Col lg="5">
                                  Purchase Unit
                                </Col>
                                <Col lg="5">
                                  Sale Unit
                                </Col>
                              </Row>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  {(unitConversionRows || []).map((formRow, key) => (
                                    <tr key={key}>
                                      <td>
                                        <Row className="mb-1 no-gutters">
                                          <Col lg="1" xs="1">
                                            <Input
                                              type="text"
                                              disabled
                                              className="nopadd text-center form-control"
                                              value={1}
                                            />
                                          </Col>
                                          <Col lg="3" xs="3">
                                            <Input
                                              type="text"
                                              disabled
                                              className="nopadd text-center form-control"
                                              value={productDetails.productunitname}
                                            />
                                          </Col>
                                          <Col lg="1" xs="1">
                                            <Input
                                              type="text"
                                              disabled
                                              className="nopadd text-center form-control"
                                              value={"="}
                                            />
                                          </Col>
                                          <Col lg="2" xs="2">
                                            <Input
                                              type="text"
                                              className="nopadd text-center form-control"
                                              placeholder={"Enter qty "}
                                              onChange={e => {
                                                if(isNumber(e.target.value)){
                                                  handleUnitValueChange(formRow.idx, e.target.value)
                                                  validateTextNumberInput("productmultiunitval-"+formRow.idx, e.target.value)
                                                }
                                              }}
                                              value={(unitConversionRows.filter(x => x["idx"]==formRow.idx)[0].conversionvalue)}
                                            />
                                            {(validation["productmultiunitval-"+formRow.idx] === false) &&
                                              <div className="custom-error">
                                                Enter rate
                                              </div>
                                            }
                                          </Col>
                                          <Col lg="3">
                                            <div className="ajax-select mt-3 mt-lg-0 select2-container">
                                              <Select
                                                onChange={(e) => {
                                                  handleUnitChange(formRow.idx,e)
                                                  validateMultiUnitChange('productmultiunit-'+formRow.idx,e.value)
                                                  //onChangeValidation("productunit", e.value)
                                                }}
                                                value={getSelectedUnit(formRow.idx)}
                                                options={getMultiUnitOptions(formRow.idx)}
                                                classNamePrefix="select2-selection"
                                                isLoading={false}
                                                id="productmunit"
                                              />
                                            </div>
                                            {(validation["productmultiunit-"+formRow.idx] === false) &&
                                              <div className="custom-error">
                                                Please select the Unit
                                              </div>
                                            }
                                            {(validation["productmultiunitduplicate-"+formRow.idx] === false) &&
                                              <div className="custom-error">
                                                Please select a different Unit
                                              </div>
                                            }

                                          </Col>
                                          <Col lg="2" xs="12" className="justify-content-center align-self-center text-center">
                                            <div className="add-remove-mob">
                                              <Button
                                                color="info"
                                                className="btn-sm btn-info ms-2 me-2"
                                                onClick={() => {
                                                  addMoreRows(formRow.idx)
                                                }}
                                                disabled={(unitConversionRows.length!=formRow.idx) || formRow.idx > 4}
                                              >
                                                <i className="fas fa-plus"></i> 
                                              </Button>

                                              <Button
                                                color="danger"
                                                className="btn-sm btn-info "
                                                onClick={() => {
                                                  handleRemoveOneRow(formRow, formRow.idx)
                                                }}
                                                disabled={unitConversionRows.length ==1}
                                              >
                                                <i className="fas fa-minus"></i> 
                                              </Button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            </Col>
                            </Row>}


                          </Form>
                        </TabPane>

                        <TabPane tabId={2}>
                          <div className="row justify-content-center">
                            <Label>
                              Sales
                            </Label>
                            <hr/>
                            <Row className="mb-3">
                                <Col lg="4">
                                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                    <Label>
                                      Sales Account
                                    </Label>
                                    <COADropDown 
                                      id={productForEdit.saleaccountid}
                                      groupCode="SA"
                                      accountType="SALE"
                                      selectOnChange={e =>{
                                        setSaleaccountid(e.value)
                                      }}
                                      >
                                    </COADropDown>
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                    <Label>
                                      Sales Discounts Account
                                    </Label>
                                    <COADropDown 
                                      id={productDetails.salediscountaccountid}
                                      groupCode="SA"
                                      accountType="DISC"
                                      selectOnChange={e =>{
                                        setSalediscountaccountid(e.value)
                                      }}
                                      >
                                    </COADropDown>
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                    <Label>
                                      Sales Return Account
                                    </Label>
                                    <COADropDown 
                                      id={productDetails.salereturnaccountid}
                                      groupCode="SA"
                                      accountType="RETN"
                                      selectOnChange={e =>{
                                        setSalereturnaccountid(e.value)
                                      }}
                                      >
                                    </COADropDown>
                                  </div>
                                </Col>
                              </Row>
                              <Label>
                                  Purchase
                              </Label>
                              <hr/>
                              <Row>
                                <Col lg="4">
                                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                    <Label>
                                      Purchase Account
                                    </Label>
                                    <COADropDown 
                                      id={productDetails.purchaseaccountid}
                                      groupCode="PU"
                                      accountType="PRCH"
                                      selectOnChange={e =>{
                                        setPurchaseaccountid(e.value)
                                      }}
                                      >
                                    </COADropDown>
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                    <Label>
                                      Purchase Discounts Account
                                    </Label>
                                    <COADropDown 
                                      id={productDetails.purchasediscountaccountid}
                                      groupCode="PU"
                                      accountType="DISC"
                                      selectOnChange={e =>{
                                        setPurchasediscountaccountid(e.value)
                                      }}
                                      >
                                    </COADropDown>
                                  </div>
                                </Col>
                                <Col lg="4">
                                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                    <Label>
                                      Purchase Return Account
                                    </Label>
                                    <COADropDown 
                                      id={productDetails.purchasereturnaccountid}
                                      groupCode="PU"
                                      accountType="RETN"
                                      selectOnChange={e =>{
                                        setPurchasereturnaccountid(e.value)
                                      }}
                                      >
                                    </COADropDown>
                                  </div>
                                </Col>
                              </Row>
                              
                          </div>
                        </TabPane>

                        <TabPane tabId={3}>
                          <Form>
                            <Row>
                              <Col lg="8">
                                <div className="mb-3">
                                  <Label for="productaltname">
                                    Product Alternative Name
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="productaltname"
                                    maxLength="100"
                                    value={productDetails.productaltname || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productaltname : e.target.value
                                      })
                                      onChangeValidation("productaltname", e.target.value.trim())
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg="4">
                                <div className="mb-3">
                                  <Label for="productsku">
                                    SKU
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="productsku"
                                    maxLength="150"
                                    value={productDetails.productsku || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productsku : e.target.value
                                      })
                                      onChangeValidation("productsku", e.target.value.trim())
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="3">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productcolour">
                                    Colour
                                  </Label>
                                  <CreatableSelect
                                    value={selectedColour}
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productcolour : e.value
                                      })
                                      setSelectedColour(e)
                                      onChangeValidation("productcolour", e.value)
                                    }}
                                    options={colourList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productcolour"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Colour')
                                    }}
                                  />
                                </div>
                              </Col>

                              <Col lg="3">
                                <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                                  <Label for="productsize">
                                    Size
                                  </Label>
                                  <CreatableSelect
                                    onChange={(e) => {
                                      setProductDetails({
                                        ...productDetails,
                                        productsize : e.value
                                      })
                                      setSelectedSize(e)
                                    }}
                                    value={selectedSize}
                                    options={sizeList}
                                    classNamePrefix="select2-selection"
                                    isLoading={false}
                                    id="productsize"
                                    onCreateOption={(e) => {
                                      setEnteredText(e)
                                      addNewItem('Size')
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg="2" >
                                <div className="mb-3">
                                  <Label for="productwebactive">
                                    Product Web Active
                                  </Label>
                                  <div className="square-switch mt-2">
                                    <input
                                      type="checkbox"
                                      id="square-switch2"
                                      switch="none"
                                      checked={productDetails.productwebactive}
                                      onChange={() => {
                                        setProductDetails({
                                          ...productDetails,
                                          productwebactive : !productDetails.productwebactive
                                        })
                                      }}
                                    />
                                    <label
                                      htmlFor="square-switch2"
                                      data-on-label="Yes"
                                      data-off-label="No"
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <div className="inner-repeater mb-4">
                              <Label>Highlights</Label>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  {(highlightRows || []).map((formRow, key) => (
                                    <tr key={key}>
                                      <td>
                                        <Row className="mb-2">
                                          <Col lg="10" xs="12">
                                            <Input
                                              type="text"
                                              className="inner form-control"
                                              placeholder={"Enter your Highlights... "+formRow.idx}
                                              onChange={e => {
                                                handleHighlightsChange(formRow.idx, e.target.value)
                                              }}
                                              value={(highlightRows.filter(x => x["idx"]==formRow.idx)[0].value)}
                                            />
                                          </Col>
                                          <Col lg="2" xs="12">
                                            <div className="add-remove-mob">
                                              <Button
                                                color="info"
                                                className="btn btn-info me-2"
                                                onClick={() => {
                                                  handleAddRowHighlights()
                                                }}
                                                disabled={(highlightRows.length!=formRow.idx) || formRow.idx > 9}
                                              >
                                                <i className="fas fa-plus"></i> 
                                              </Button>
                                              <Button
                                                color="danger"
                                                className="btn btn-info "
                                                onClick={() => {
                                                  handleRemoveRowHighlights(formRow, formRow.idx)
                                                }}
                                                disabled={highlightRows.length ==1}
                                              >
                                                <i className="fas fa-minus"></i> 
                                              </Button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            <div className="inner-repeater mb-4">
                              <Label>Specifications</Label>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  {(specificationRows || []).map((formRow, key) => (
                                    <tr key={key}>
                                      <td>
                                        <Row className="mb-2">
                                          <Col lg="5" xs="6">
                                            <Input
                                              type="text"
                                              className="inner form-control"
                                              placeholder={"Enter Key... "+formRow.idx}
                                              onChange={e => {
                                                handleSpecificationsChangeKey(formRow.idx, e.target.value)
                                              }}
                                              value={(specificationRows.filter(x => x["idx"]==formRow.idx)[0].key)}
                                            />
                                          </Col>
                                          <Col lg="5" xs="6">
                                            <Input
                                              type="text"
                                              className="inner form-control"
                                              placeholder={"Enter Value... "+formRow.idx}
                                              onChange={e => {
                                                handleSpecificationsChangeValue(formRow.idx, e.target.value)
                                              }}
                                              value={(specificationRows.filter(x => x["idx"]==formRow.idx)[0].value)}
                                            />
                                          </Col>
                                          <Col lg="2" xs="12">
                                            <div className="add-remove-mob">
                                              <Button
                                                color="info"
                                                className="btn btn-info me-2"
                                                onClick={() => {
                                                  handleAddRowSpecifications()
                                                }}
                                                disabled={(specificationRows.length!=formRow.idx) || formRow.idx > 9}
                                              >
                                                <i className="fas fa-plus"></i> 
                                              </Button>

                                              <Button
                                                color="danger"
                                                className="btn btn-info "
                                                onClick={() => {
                                                  handleRemoveRowSpecifications(formRow, formRow.idx)
                                                }}
                                                disabled={specificationRows.length ==1}
                                              >
                                                <i className="fas fa-minus"></i> 
                                              </Button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            <CustomTextEditor reset={reset} initialValue={initialproductdescription} onTextEditorValueChange={onTextEditorValueChange}></CustomTextEditor>
                            
                          </Form>
                        </TabPane>
                        <TabPane tabId={4}>
                          <div>
                            <FileUpload reset={reset} initialFiles={initialproductimages} onFileUploadValueChange={onFileUploadValueChange}></FileUpload>
                          </div>
                        </TabPane>
                        <TabPane tabId={5}>
                          <div className="row justify-content-center">
                          <Row>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="basicpill-meta-title">
                                    Meta Title
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="basicpill-meta-title"
                                    maxLength="100"
                                    value={productDetails.productmetatitle || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productmetatitle : e.target.value
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="basicpill-meta-keywords">
                                    Meta KeyWords
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="basicpill-meta-keywords"
                                    maxLength="200"
                                    value={productDetails.productmetakeywords || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productmetakeywords : e.target.value
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="basicpill-meta-description">
                                    Meta Description
                                  </Label>
                                  <textarea
                                    id="basicpill-meta-description"
                                    className="form-control"
                                    rows="4"
                                    maxLength="300"
                                    value={productDetails.productmetadescription || ''}
                                    onChange={e => {
                                      setProductDetails({
                                        ...productDetails,
                                        productmetadescription : e.target.value
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li
                          className={activeTab === 5 ? "next disabled" : "next"}
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              toggleTab(activeTab + 1)
                            }}
                          >
                            Next
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="text-center clearfix">
                      {isEdit && 
                      <Button
                      color="success"
                      className="btn w-lg btn-success "
                      onClick={() => {
                        saveEditProduct()
                      }}
                      >
                        UPDATE PRODUCT
                    </Button>
                    }
                    {!isEdit && 
                      <Button
                        color="success"
                        className="btn w-lg btn-success "
                        onClick={() => {
                          addProduct()
                        }}
                        >
                          ADD PRODUCT
                      </Button>
                      }
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          categorySubCategoryMap={categorySubCategory}
          selectedId={productDetails.productcategory}
          enteredText={enteredText}
        />
      </ReactDrawer>
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
      {showSuccessPopUp ? (
        <SweetAlert
          title="Success!"
          success
          customButtons={
            <>
            <Button
              color="warning"
              className="btn btn-warning me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                onContinueEditing()
              }}
              >
                <i className="mdi mdi-pencil me-1"></i>Continue Editing
            </Button>

            <Button
              color="primary"
              className="btn btn-primary me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                onCreateNewProduct()
              }}
              >
                <i className="bx bx-plus me-1"></i>Add New Product
            </Button>

            {lastPurchaseDraft && 
            <Button
              color="info"
              className="btn btn-success mt-1"
              onClick={() => {
                handleBackToPurchase()
              }}
              >
                <i className="bx bx-left-arrow-alt me-1"></i>Back to Purchase Entry
            </Button>
            }
            </>
          }
          onConfirm={() => {
            setShowSuccessPopUp(false)
          }}
        >
          {successMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

AddProduct.propTypes = {
  categorySubCategory: PropTypes.array,
  supplierList: PropTypes.array,
  brandList: PropTypes.array,
  taxList: PropTypes.array,
  manufacturerList: PropTypes.array,
  unitList: PropTypes.array,
  hsnList: PropTypes.array,
  colourList: PropTypes.array,
  sizeList: PropTypes.array,

  onGetCategoriesAndSubCategories: PropTypes.func,
  onGetAllBrands: PropTypes.func,
  onGetAllTaxes: PropTypes.func,
  onGetAllManufacturers: PropTypes.func,
  onGetAllUnits: PropTypes.func,
  onGetAllHSNs: PropTypes.func,
  onGetAllColours: PropTypes.func,
  onGetAllSizes: PropTypes.func,
}

export default AddProduct
